import { ReactNode } from 'react';
import { useWebSocket } from '@shared/hooks/useWebSocket';
import { WebSocketContext } from './WebSocketContext';

interface WebSocketProviderProps {
  children: ReactNode;
}

function WebSocketProvider({ children }: WebSocketProviderProps) {
  const { isConnected, send, registerHandlers } = useWebSocket();

  return (
    <WebSocketContext.Provider value={{ isConnected, send, registerHandlers }}>
      {children}
    </WebSocketContext.Provider>
  );
}

export default WebSocketProvider;

